// Flow Configuration - Screen definitions and navigation
export const FLOW_CONFIG = {
  initialScreen: 'age',
  // Phase 1: Discovery and Personalization
  phase1: [
    {
      id: 'age',
      hash: '#age',
      template: 'screen-age',
      dataField: 'age_range',
      preload: { when: 'onload', what: 'images' },
      analytics: { screen_name: 'age_selection' }
    },
    {
      id: 'research-fact',
      hash: '#research-fact',
      template: 'screen-research-fact',
      analytics: { screen_name: 'research_fact' }
    },
    {
      id: 'primary-goal',
      hash: '#primary-goal',
      template: 'screen-primary-goal',
      dataField: 'primary_goal',
      analytics: { screen_name: 'primary_goal_selection' }
    },
    {
      id: 'additional-concerns',
      hash: '#additional-concerns',
      template: 'screen-additional-concerns',
      dataField: 'additional_concerns',
      multiSelect: true,
      analytics: { screen_name: 'additional_concerns_selection' }
    },
    // {
    //   id: 'social-proof',
    //   hash: '#social-proof',
    //   template: 'screen-social-proof',
    //   analytics: { screen_name: 'social_proof_interstitial' }
    // },
    {
      id: 'skin-type',
      hash: '#skin-type',
      template: 'screen-skin-type',
      dataField: 'skin_type',
      analytics: { screen_name: 'skin_type_selection' }
    },
    {
      id: 'not-alone',
      hash: '#not-alone',
      template: 'screen-not-alone',
      analytics: { screen_name: 'not_alone_interstitial' }
    },
    {
      id: 'ready-35',
      hash: '#ready_35',
      template: 'screen-ready-35',
      analytics: { screen_name: 'ready_35_progress' }
    },
    {
      id: 'routine-consistency',
      hash: '#routine-consistency',
      template: 'screen-routine-consistency',
      dataField: 'routine_consistency',
      analytics: { screen_name: 'routine_consistency_selection' }
    },
    {
      id: 'current-products',
      hash: '#current-products',
      template: 'screen-current-products',
      dataField: 'current_products',
      multiSelect: true,
      analytics: { screen_name: 'current_products_selection' }
    },
    {
      id: 'smart-investment',
      hash: '#smart-investment',
      template: 'screen-smart-investment',
      analytics: { screen_name: 'smart_investment_info' }
    },
    {
      id: 'retinol',
      hash: '#retinol',
      template: 'screen-retinol',
      dataField: 'retinol_experience',
      analytics: { screen_name: 'retinol_experience_selection' }
    },
    {
      id: 'parabens',
      hash: '#parabens',
      template: 'screen-parabens',
      dataField: 'paraben_preference',
      analytics: { screen_name: 'paraben_preference_selection' }
    },
    {
      id: 'acids',
      hash: '#acids',
      template: 'screen-acids',
      dataField: 'acid_preference',
      analytics: { screen_name: 'acid_preference_selection' }
    },
    {
      id: 'antioxidant',
      hash: '#antioxidant',
      template: 'screen-antioxidant',
      dataField: 'antioxidant_usage',
      analytics: { screen_name: 'antioxidant_usage_selection' }
    },
    {
      id: 'ready-67',
      hash: '#ready_67',
      template: 'screen-ready-67',
      analytics: { screen_name: 'ready_67_progress' }
    },
    {
      id: 'moisturizing',
      hash: '#moisturizing',
      template: 'screen-moisturizing',
      dataField: 'hydration_level',
      analytics: { screen_name: 'moisturizing_selection' }
    },
    {
      id: 'sensitivity',
      hash: '#sensitivity',
      template: 'screen-sensitivity',
      dataField: 'sensitivity_level',
      analytics: { screen_name: 'sensitivity_selection' }
    },
    {
      id: 'ready-89',
      hash: '#ready_89',
      template: 'screen-ready-89',
      analytics: { screen_name: 'ready_89_progress' }
    },
    {
      id: 'sleeping',
      hash: '#sleeping',
      template: 'screen-sleeping',
      dataField: 'sleep_duration',
      analytics: { screen_name: 'sleep_duration_selection' }
    },
    {
      id: 'water',
      hash: '#water',
      template: 'screen-water',
      dataField: 'water_intake',
      analytics: { screen_name: 'water_intake_selection' }
    },
    {
      id: 'stress',
      hash: '#stress',
      template: 'screen-stress',
      dataField: 'stress_level',
      analytics: { screen_name: 'stress_level_selection' }
    },
    {
      id: 'routine-duration',
      hash: '#routine-duration',
      template: 'screen-routine-duration',
      dataField: 'routine_duration',
      analytics: { screen_name: 'routine_duration_selection' }
    },
    // {
    //   id: 'sun-behavior',
    //   hash: '#sun-behavior',
    //   template: 'screen-sun-behavior',
    //   dataField: 'sun_behavior',
    //   analytics: { screen_name: 'sun_behavior_selection' }
    // },
    // {
    //   id: 'routine-complexity',
    //   hash: '#routine-complexity',
    //   template: 'screen-routine-complexity',
    //   dataField: 'routine_complexity',
    //   analytics: { screen_name: 'routine_complexity_selection' }
    // },
    // {
    //   id: 'spf-usage',
    //   hash: '#spf-usage',
    //   template: 'screen-spf-usage',
    //   dataField: 'spf_usage',
    //   analytics: { screen_name: 'spf_usage_selection' }
    // },
    // {
    //   id: 'makeup-frequency',
    //   hash: '#makeup-frequency',
    //   template: 'screen-makeup-frequency',
    //   dataField: 'makeup_frequency',
    //   analytics: { screen_name: 'makeup_frequency_selection' }
    // },
    {
      id: 'harvard-fact',
      hash: '#harvard-fact',
      template: 'screen-harvard-fact',
      analytics: { screen_name: 'harvard_fact' }
    },
    {
      id: 'ready-96',
      hash: '#ready_96',
      template: 'screen-ready-96',
      analytics: { screen_name: 'ready_96_progress' }
    },
    {
      id: 'app-goals',
      hash: '#app-goals',
      template: 'screen-app-goals',
      dataField: 'app_goals',
      multiSelect: true,
      analytics: { screen_name: 'app_goals_selection' }
    },
    {
      id: 'mood',
      hash: '#mood',
      template: 'screen-mood',
      dataField: 'mood_goals',
      multiSelect: true,
      preload: { when: 'onload', what: 'images' },
      analytics: { screen_name: 'mood_goals_selection' }
    },
    {
      id: 'motivation',
      hash: '#motivation',
      template: 'screen-motivation',
      dataField: 'skincare_aspiration',
      multiSelect: true,
      preload: { when: 'onload', what: 'images' },
      analytics: { screen_name: 'skincare_aspiration_selection' }
    },
    // {
    //   id: 'medical',
    //   hash: '#medical',
    //   template: 'screen-medical',
    //   dataField: 'medical_considerations',
    //   multiSelect: true,
    //   analytics: { screen_name: 'medical_considerations_selection' }
    // },
    // {
    //   id: 'ingredients',
    //   hash: '#ingredients',
    //   template: 'screen-ingredients',
    //   dataField: 'excluded_ingredients',
    //   multiSelect: true,
    //   analytics: { screen_name: 'ingredient_exclusions_selection' }
    // },
    // {
    //   id: 'budget',
    //   hash: '#budget',
    //   template: 'screen-budget',
    //   dataField: 'monthly_budget',
    //   analytics: { screen_name: 'budget_selection' }
    // },
    // {
    //   id: 'location',
    //   hash: '#location',
    //   template: 'screen-location',
    //   dataField: 'location',
    //   analytics: { screen_name: 'location_input' }
    // },
    // {
    //   id: 'lifestyle',
    //   hash: '#lifestyle',
    //   template: 'screen-lifestyle',
    //   dataField: 'lifestyle_factors',
    //   multiSelect: true,
    //   analytics: { screen_name: 'lifestyle_factors_selection' }
    // },
    // {
    //   id: 'allergies',
    //   hash: '#allergies',
    //   template: 'screen-allergies',
    //   next: 'processing',
    //   back: 'lifestyle',
    //   dataField: 'allergies_intolerances',
    //   optional: true,
    //   analytics: { screen_name: 'allergies_input' }
    // },
    {
      id: 'processing',
      hash: '#processing',
      template: 'screen-processing',
      duration: 8000, // 8 seconds
      analytics: { screen_name: 'processing_analysis' }
    }
  ],

  // Phase 2: Results Generation and Conversion
  phase2: [
    {
      id: 'email',
      hash: '#email',
      template: 'screen-email',
      next: 'selfie-intro',
      back: 'allergies',
      dataField: 'email',
      required: true,
      validation: 'email',
      analytics: { screen_name: 'email_capture' }
    },
    {
      id: 'selfie-intro',
      hash: '#selfie-intro',
      template: 'screen-selfie-intro',
      next: 'camera',
      back: 'email',
      analytics: { screen_name: 'selfie_introduction' }
    },
    {
      id: 'camera',
      hash: '#camera',
      template: 'screen-camera',
      next: 'analysis',
      back: 'selfie-intro',
      dataField: 'selfie',
      requiresCamera: true,
      preload: { when: {type: 'screens-before', count: 10}, what: 'camera-detection' },
      analytics: { screen_name: 'camera_capture' }
    },
    {
      id: 'analysis',
      hash: '#analysis',
      template: 'screen-analysis',
      next: 'results',
      duration: 15000, // 15 seconds
      analytics: { screen_name: 'ai_analysis_loading' }
    },
    {
      id: 'results',
      hash: '#results',
      template: 'screen-results',
      next: 'prediction',
      back: null,
      analytics: { screen_name: 'results_summary' }
    },
    // {
    //   id: 'plan',
    //   hash: '#plan',
    //   template: 'screen-plan',
    //   next: 'prediction',
    //   back: 'results',
    //   analytics: { screen_name: 'action_plan_preview' }
    // },
    {
      id: 'prediction',
      hash: '#prediction',
      template: 'screen-prediction',
      next: 'subscription',
      back: 'results',
      analytics: { screen_name: 'goal_state_prediction' }
    }
  ],

  // Phase 3: Conversion and Paywall
  phase3: [
    {
      id: 'subscription',
      hash: '#checkout',
      template: 'screen-subscription',
      next: 'success',
      back: 'prediction',
      timer: 600, // 10 minutes in seconds
      analytics: { screen_name: 'paywall' }
    },
    {
      id: 'success',
      hash: '#success',
      template: 'screen-success',
      next: null,
      back: null,
      analytics: { screen_name: 'success' }
    }
  ],

  // Get all screens in order
  getAllScreens() {
    return [...this.phase1, ...this.phase2, ...this.phase3];
  },

  // Get screen by ID
  getScreenById(id) {
    return this.getAllScreens().find(screen => screen.id === id);
  },

  // Get screen by hash
  getScreenByHash(hash) {
    return this.getAllScreens().find(screen => screen.hash === hash);
  },

  // Get next screen
  getNextScreen(currentId) {
    const current = this.getScreenById(currentId);
    if (!current) return null;

    // If next is explicitly defined, use it
    if (current.next !== undefined) {
      return current.next ? this.getScreenById(current.next) : null;
    }

    // Otherwise, use the next item in the list
    const screens = this.getAllScreens();
    const currentIndex = screens.findIndex(screen => screen.id === currentId);
    if (currentIndex >= 0 && currentIndex < screens.length - 1) {
      return screens[currentIndex + 1];
    }
    return null;
  },

  // Get previous screen
  getPreviousScreen(currentId) {
    const current = this.getScreenById(currentId);
    if (!current) return null;

    // If back is explicitly defined, use it
    if (current.back !== undefined) {
      return current.back ? this.getScreenById(current.back) : null;
    }

    // Otherwise, use the previous item in the list
    const screens = this.getAllScreens();
    const currentIndex = screens.findIndex(screen => screen.id === currentId);
    if (currentIndex > 0) {
      return screens[currentIndex - 1];
    }
    return null;
  },

  // Get total screen count
  getTotalScreens() {
    return this.getAllScreens().length;
  },

  // Get screen index
  getScreenIndex(id) {
    const screens = this.getAllScreens();
    return screens.findIndex(screen => screen.id === id) + 1;
  }
};